var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-layout"},[_c('nuxt'),_vm._v(" "),_c('Inactivity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }